<div class="a3l-ui-helper" [innerHTML]="message" [@state]="visibility" (@state.done)="onAnimationDone($event)"></div>
